import {GameWinPresentationInitialState} from 'src/winpresentation/states/GameWinPresentationInitialState';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {WildMeterEvents} from 'src/wildmeter/WildMeterEvents';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';
import {GameWinPresentationView} from 'src/winpresentation/GameWinPresentationView';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';

export class GameWinPresentationInitialWinWithMultiplierState extends GameWinPresentationInitialState {
	protected setupEvents(): void {
		super.setupEvents();

		this.on(WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED, this.onWinMeterWinExitAnimationFinished);
		this.on(GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED, this.onAfterMultiplierCountingFinished);
		this.on(SpinButtonEvents.SKIP_BY_SPIN_BUTTON_PRESSED, this.onSkipBySpinButtonClicked);
	}

	/*
	If multiplier > 1
	1) win amount moves swiftly from win field to center reels
	2) Multiplier moves shortly after and hits win.
	3b) Win counts normally from unmultiplied to multiplied amount
	 */
	protected startInitialWinPresentation(): void {
		const logic: GameRecodeLogic = (this.module.logic as GameRecodeLogic);

		this.emit(GameWinPresentationEvents.COUNTING_STARTED, logic.getLastAvalancheRunningTotal());
		this.view.playWinNumberCounter(logic.getLastAvalancheRunningTotal(),
			false, // no countup here
			0,
			false);

		this.emit(WinPresentationEvents.INITIAL_ANIMATION_STARTED);
	}

	protected onWinMeterWinExitAnimationFinished(): void {
		this.emit(SpinButtonEvents.DISABLE_SPIN_BY_SPIN);
		const logic: GameRecodeLogic = (this.module.logic as GameRecodeLogic);

		const playCountUpSound: boolean = true;
		this.emit(GameWinPresentationEvents.COUNTING_STARTED, logic.currentSpinWin - logic.getLastAvalancheRunningTotal(), playCountUpSound);
		(this.view as GameWinPresentationView).playCountingFormToAfterMultiplier(logic.getLastAvalancheRunningTotal(), logic.currentSpinWin);
	}

	protected onSkipBySpinButtonClicked(): void {
		(this.view as GameWinPresentationView).skipCountUp();
	}

	protected onAfterMultiplierCountingFinished(): void {
		this.module.timeUtils.createTimer(() => {
			this.onWinAnimationFinished();
		}, 500);
	}

	protected tryToFinishWinPresentation(): void {

	}

}



// WEBPACK FOOTER //
// ./src/winpresentation/states/GameWinPresentationInitialWinWithMultiplierState.ts